'use client';

import { usePathname } from 'next/navigation';
import { useAnnouncements } from './AnnouncementsProvider';

export default function AnnouncementBanner() {
  const pathname = usePathname();
  const { visible, hideAndKeep, hideForever } = useAnnouncements();

  if (pathname === '/login') return null;
  if (visible.length === 0) return null;

  return (
    <div className="marquesina" role="region" aria-label="Avisos">
      {visible.map(a => (
        <div key={a.id} className="marquesina-item">
          <span className="marquesina-icon" aria-hidden="true">📢</span>
          <span className="marquesina-text">{a.message}</span>
          {a.url && (
            <a href={a.url} target="_blank" rel="noopener noreferrer" className="marquesina-link">
              {a.url_label || 'Ver más'} ↗
            </a>
          )}
          <div className="marquesina-actions">
            <button
              type="button"
              className="marquesina-btn"
              onClick={() => hideAndKeep(a.id)}
              title="Ocultar el aviso, pero mantenerlo disponible en la barra superior"
            >
              Ocultar y mantener
            </button>
            <button
              type="button"
              className="marquesina-btn marquesina-btn-forever"
              onClick={() => hideForever(a.id)}
              title="Ocultar el aviso y no volver a mostrarlo"
            >
              Ocultar por siempre
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
